import React from "react";
import { Box, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";
import BorderedTable from "./BorderedTable";

const BorderedTableComponent = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Bordered Table
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          value={
            " <TableContainer>\n" +
            '        <Table variant={"bordered"}>\n' +
            "          <TableHead>\n" +
            "            <TableRow>\n" +
            "              <TableCell>\n" +
            '                <Stack direction="row" alignItems="center">\n' +
            '                  <Checkbox size={"small"} />\n' +
            "                  User\n" +
            "                </Stack>\n" +
            "              </TableCell>\n" +
            "              <TableCell>Email</TableCell>\n" +
            "              <TableCell>\n" +
            "                <Stack\n" +
            '                  direction={"row"}\n' +
            '                  justifyContent={"space-between"}\n' +
            '                  alignItems="center"\n' +
            "                >\n" +
            "                  <span>Phone</span>\n" +
            '                  <IconButton size={"small"}>\n' +
            '                    <ChevronUpDownIcon fontSize={"small"} />\n' +
            "                  </IconButton>\n" +
            "                </Stack>\n" +
            "              </TableCell>\n" +
            "              <TableCell>Account status</TableCell>\n" +
            "            </TableRow>\n" +
            "          </TableHead>\n" +
            "          <TableBody>\n" +
            "            <TableRow>\n" +
            "              <TableCell>\n" +
            "                <NameAvatar>\n" +
            '                  <Checkbox size={"small"} />\n' +
            "                </NameAvatar>\n" +
            "              </TableCell>\n" +
            "              <TableCell>jss@gmail.com </TableCell>\n" +
            "              <TableCell>1234908 </TableCell>\n" +
            "              <TableCell>\n" +
            "                <Chip\n" +
            '                  label="Active"\n' +
            '                  color="success"\n' +
            '                  size="xSmall"\n' +
            '                  variant="outlined"\n' +
            "                />\n" +
            "              </TableCell>\n" +
            "            </TableRow>\n" +
            "            <TableRow>\n" +
            "              <TableCell>\n" +
            "                <NameAvatar>\n" +
            '                  <Checkbox size={"small"} />\n' +
            "                </NameAvatar>\n" +
            "              </TableCell>\n" +
            "              <TableCell>jss@gmail.com </TableCell>\n" +
            "              <TableCell>1234908 </TableCell>\n" +
            "              <TableCell>\n" +
            "                <Chip\n" +
            '                  label="Active"\n' +
            '                  color="success"\n' +
            '                  size="xSmall"\n' +
            '                  variant="outlined"\n' +
            "                />\n" +
            "              </TableCell>\n" +
            "            </TableRow>\n" +
            "            <TableRow>\n" +
            "              <TableCell>\n" +
            "                <NameAvatar>\n" +
            '                  <Checkbox size={"small"} />\n' +
            "                </NameAvatar>\n" +
            "              </TableCell>\n" +
            "              <TableCell>jss@gmail.com </TableCell>\n" +
            "              <TableCell>1234908 </TableCell>\n" +
            "              <TableCell>\n" +
            "                <Chip\n" +
            '                  label="Active"\n' +
            '                  color="success"\n' +
            '                  size="xSmall"\n' +
            '                  variant="outlined"\n' +
            "                />\n" +
            "              </TableCell>\n" +
            "            </TableRow>\n" +
            "            <TableRow>\n" +
            "              <TableCell>\n" +
            "                <NameAvatar>\n" +
            '                  <Checkbox size={"small"} />\n' +
            "                </NameAvatar>\n" +
            "              </TableCell>\n" +
            "              <TableCell>jss@gmail.com </TableCell>\n" +
            "              <TableCell>1234908</TableCell>\n" +
            "              <TableCell>\n" +
            "                <Chip\n" +
            '                  label="Active"\n' +
            '                  color="success"\n' +
            '                  size="xSmall"\n' +
            '                  variant="outlined"\n' +
            "                />\n" +
            "              </TableCell>\n" +
            "            </TableRow>\n" +
            "            <TableRow>\n" +
            "              <TableCell>\n" +
            "                <NameAvatar>\n" +
            '                  <Checkbox size={"small"} />\n' +
            "                </NameAvatar>\n" +
            "              </TableCell>\n" +
            "              <TableCell>jss@gmail.com </TableCell>\n" +
            "              <TableCell>1234908</TableCell>\n" +
            "              <TableCell>\n" +
            "                <Chip\n" +
            '                  label="Active"\n' +
            '                  color="success"\n' +
            '                  size="xSmall"\n' +
            '                  variant="outlined"\n' +
            "                />\n" +
            "              </TableCell>\n" +
            "            </TableRow>\n" +
            "            <TableRow>\n" +
            "              <TableCell>\n" +
            "                <NameAvatar>\n" +
            '                  <Checkbox size={"small"} />\n' +
            "                </NameAvatar>\n" +
            "              </TableCell>\n" +
            "              <TableCell>jss@gmail.com </TableCell>\n" +
            "              <TableCell>1234908 </TableCell>\n" +
            "              <TableCell>\n" +
            "                <Chip\n" +
            '                  label="Active"\n' +
            '                  color="success"\n' +
            '                  size="xSmall"\n' +
            '                  variant="outlined"\n' +
            "                />\n" +
            "              </TableCell>\n" +
            "            </TableRow>\n" +
            "          </TableBody>\n" +
            "        </Table>\n" +
            "      </TableContainer>"
          }
        >
          <BorderedTable />
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default BorderedTableComponent;
